<template>
  <div class="content-wrapper">
    <ContentHeader title="Наряды" />
    <div class="content-body">
      <card
        headerTitle="История нарядов"
        :busy="isWorkOrdersLoading"
        hideFooter
        @reload="reloadWorkOrders"
      >
        <template slot="block">
          <form class="form-inline row">
            <div class="from-group col-sm-2">
              <a href="/workorder/null" class="btn btn-secondary btn-min-width router-link-active">
                  <i class="icon-new"></i> Создать наряд </a>
            </div>
            <div class="from-group col-sm-8">
              <div class="form-check form-check-inline">
                  <label><input class="form-check-input" type="radio" name="wokrorderFilter" :value="null" v-model="filter" />  Все  </label>
              </div>
              <div class="form-check form-check-inline">
                  <label><input class="form-check-input" type="radio" name="wokrorderFilter" :value="'created'" v-model="filter" />  Созданные  </label>
              </div>
              <div class="form-check form-check-inline">
                  <label><input class="form-check-input" type="radio" name="wokrorderFilter" :value="'finished'" v-model="filter" />  Выполненные  </label>
              </div>
              <div class="form-check form-check-inline">
                  <label><input class="form-check-input" type="radio" name="wokrorderFilter" :value="'in_progress'" v-model="filter" />  Выполняется  </label>
              </div>
              <div class="form-check form-check-inline">
                  <label><input class="form-check-input" type="radio" name="wokrorderFilter" :value="'deleted'" v-model="filter" />  Удалены  </label>
              </div>
            </div>
          </form>
          <br />

          <b-table
            show-empty
            hover
            bordered
            responsive
            thead-class="bg-grey bg-lighten-2"
            :emptyText="
              isWorkOrdersFailed
                ? 'Ошибка подключения. Попробуйте позже'
                : 'Записи отсутствуют'
            "
            emptyFilteredText="Записи не найдены"
            _sort-compare= "sortingChanged"

            :busy="isWorkOrdersLoading"            
            :items="getWorkOrders"
            :fields="workOrdersFields"

            :sort-by="'id'"
            :sort-desc="true"

            :total-rows="totalRows"
            :per-page="perPage"
            :current-page="currentPage"

            filter="filter"
            :filterIncludedFields="['id']"
            @filtered="onFiltered"
            :filter-function="filterWorkordersTable"
            _filtered="$emit('filtered')"

            @row-clicked="editWorkOrder"

            class="table-workorderList"
             :tbody-tr-class="workorderRowClass"
          >
              <template v-slot:cell(id)="data">
                <div>
                  <!--div
                    style="cursor:pointer;text-align:center;"
                  >{{ data.value }}</div-->
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(items)="data">
                  <div                    
                    style="text-align:left;"
                    v-for="(v,i) in data.value" :key="i"
                  >{{ v }}</div>
              </template>
              <template v-slot:cell(status)="data">
                  <span :class="data.value.stateClass">{{ data.value.state }}</span>
              </template>
              <!--template v-slot:cell(station_id)="data">
                <div>
                  <div
                    _class="btn-link"                    
                    _style="cursor:pointer;text-align:center;"
                  >{{ !data.value ? '?' : (getStationsById(data.value)?getStationsById(data.value).name:'') }}</div>
                </div>
              </template>
              <template v-slot:cell(card_id)="data">
                <div>{{ data.value ? getCardName(data.value) : '?' }} </div>
              </template>
              <template v-slot:cell(acc_id)="data">
                <div>{{ getAccName(data.item.card_id) }} </div>
              </template>
              <template v-slot:cell(status)="data">
                <div 
                  style="text-align:center;"
                >{{ data.value ? orderStatusList[data.value] : '?' }}
                </div>
              </template>
              <template v-slot:cell(product_id)="data">
                <div 
                  style="text-align:center;"
                >{{ data.value ? getFuelName(data.value) : '?' }}
                </div>
              </template>
              <template v-slot:cell(requested_quantity)="data">
                <div 
                >{{ data.value == 0 ? '-' : data.value }}
                </div>
              </template>
              <template v-slot:cell(requested_sum)="data">
                <div 
                >{{ data.value == 0 ? '-' : data.value }}
                </div>
              </template-->
          </b-table>
          <div style="margin: 20px 0px;">
            <div v-if="filter==null">Всего записей: {{ totalRows }}</div>
            <div v-if="filter!=null">Найдено записей: {{ filteredRows}} из {{ totalRows }}</div>
            <div>
              <div class="float-xl-left float-sm-none mt10">
                <select
                  v-model="perPage"
                  _id="issueinput5"
                  name="priority"
                  class="form-control"
                  data-toggle="tooltip"
                  data-trigger="hover"
                  data-placement="top"
                  data-title="На страницу"
                  data-original-title
                  title
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
              <div class="float-xl-right">
                <nav aria-label="Page navigation">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    size="sm"
                    prev-text="« Пред."
                    next-text="След. »"
                    first-number
                    last-number
                  ></b-pagination>
                </nav>
              </div>
            </div>
          </div>
        </template>
      </card>
    </div>

  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import card from "@/components/card.vue";
import { mapGetters } from "vuex";
import { WORK_ORDERS_REQUEST } from "@/store/actions/workorders";

export default {
  name: "Workorders",
  components: {
    ContentHeader,
    card,
  },
  data() {
    return {
      filter: null,
        //      fields: requestFields,
      workOrderStatusList: {
          'in_progress': "Выполняется",
          'finished': "Выполнен",
          'created': "",
          'deleted': "Удален",
        },

      workOrdersFields: [
          {
            key: "id",
            label: "№",
            thClass: "text-xs-center",
            sortable: true,
          },
          {
            key: "cdate",
            label: "Дата создания",
            formatter(value) {
              return new Date(value).toLocaleString();
            },
            filterByFormatted: true,
            thClass: "text-xs-center",
            sortable: true,
          },
          {
            key: "target_date",
            label: "Дата отгрузки",
            formatter(value) {
              return new Date(value).toLocaleDateString();
            },
            filterByFormatted: true,
            thClass: "text-xs-center",
            sortable: true,
          },
          {
            key: "station_name",
            label: "Объект",
            sortable: true,
          },
          {
            key: "card_id",
            label: "Карта",
            sortable: true,
          },
          {
            key: "holder_name",
            label: "Водитель",
            sortable: true,
          },
          /*{ // virtual column for account
            key: "acc_id",
            label: "Карт-счёт",
            sortable: true,
          },*/        
          {
            key: "items",
            label: "НП / Объем",
            sortable: true,          
            formatter: (value , /*key, item*/) => {
              //console.log(value);
              let strItems = [];
              value.forEach( fuel => {
                if (fuel.status!="deleted")
                  strItems.push(fuel.product_name + ' / ' + fuel.quantity)
              })

              return strItems;
            },
          },
          {
            key: "address",
            label: "Адрес доставки",
            sortable: true,
          },
          {
            key: "status",
            label: "Статус",
            formatter: (value/*, key, item*/) => {
            //  console.log(key);
            //  console.log(item);
              let workOrderStatusList = {
                      'in_progress': "Выполняется",
                      'finished': "Выполнен",
                      'created': "",
                      'deleted': "Удален",
                  };
              let workOrderStatusClasses = {
                    'in_progress': "tag tag-default bg-blue ",
                    'finished': "tag tag-default bg-green",
                    'created': "",
                    'deleted': "tag tag-default bg-gray",
                };

              return value ? { state: workOrderStatusList[value], stateClass: workOrderStatusClasses[value]} 
                : {state: '', stateClass: ''};
            },
            thClass: "text-xs-center",
            sortable: true,
          },
      ],

      itemsPerPage: 25,
      currentPage: 1,
      perPage: this.itemsPerPage ? this.itemsPerPage : 25, 
      filteredItemsLength: -1
    };
  },
  computed: {
    ...mapGetters([
      //"getCurrencyName",

      "getWorkOrders",
      "isWorkOrdersLoading",
      "isWorkOrdersFailed",
      "workOrdersOnceLoaded",
    ]),
    filteredRows() {
      return this.filteredItemsLength>=0 ? this.filteredItemsLength : (this.getWorkOrders ? this.getWorkOrders.length : 0);
    },
    totalRows() {
      return this.getWorkOrders ? this.getWorkOrders.length : 0;
    }
  },  
  methods: {
    reloadWorkOrders() {
      this.$store.dispatch(WORK_ORDERS_REQUEST);
    },

    editWorkOrder(record/*, index*/) {
      if (record.status == 'created')
      {
        //console.log(record);
        //alert(index);

        this.$router.push({path: 'workorder/'+record.id})
      }
    },

    workorderRowClass(item, type) {
      if (item && type === 'row') {
        if (item.status == 'created')
          return 'workorder-edit'
      } else {
        return null;      }


    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItemsLength = filteredItems.length;
      this.currentPage = 1;
    },
    filterWorkordersTable( row ) {
      if (this.filter == null)
        return true;

      if (row.status == this.filter)
        return true
      else
        return false;
    }
  },
  
  created() {
    if (!this.workordersOnceLoaded) this.$store.dispatch(WORK_ORDERS_REQUEST);
  },

};
</script>

<style>
.td-number {
  text-align: right;
}
.table-workorderList td,
.table-workorderList th {  
  padding: 0.25rem 0.5rem;
}
.table-workorderList td {
  text-align: center;
}

.table-workorderList td:nth-child(8) {
  max-width: 400px;
}
.workorder-edit {
  cursor: pointer;
}
.table-workorderList tr.workorder-edit:hover {
  background-color: lightcyan;
}
</style>